import { Outlet, createFileRoute, useParams } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";
import { CertificationKind } from "@/routes/_staff/certification/-constants";

import { CertificationProfileHeader } from "../../-components/CertificationProfileHeader";
import { useGetPersonSpecialtyCertificationHeader } from "../../-queries";

export const Route = createFileRoute(
  "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, personCertificationInformationId } = useParams({
    from: "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout",
  });
  const { data } = useGetPersonSpecialtyCertificationHeader(
    id,
    personCertificationInformationId,
  );
  return (
    <VStack className="gap-0">
      <CertificationProfileHeader
        personId={id}
        personCertificationInformationId={personCertificationInformationId}
        certificationName={data.personSpecialtyCertification.certificationName}
        certificationNumber={
          data.personSpecialtyCertification.certificationNumber
        }
        certificationStatus={
          data.personSpecialtyCertification.certificationStatus
        }
        certificationKind={CertificationKind.SPECIALTY}
        certificationHolder={{
          name: data.personSpecialtyCertification.certificationHolder.name,
          avatarUrl:
            data.personSpecialtyCertification.certificationHolder.avatarUrl ??
            undefined,
        }}
      />
      <Outlet />
    </VStack>
  );
}
